module.exports = __webpack_public_path__ + "img/estadisticas.f8d14820.svg";